/**
 * Desktop navigation with dropdown functionality
 */
class DesktopNav {
  constructor() {
    this.nav = document.querySelector('.desktop-nav');
    if (!this.nav) {
      return;
    }

    this.buttons = this.nav.querySelectorAll('.desktop-nav-button');
    this.init();
  }

  init() {
    // Add click handlers to buttons
    this.buttons.forEach((button) => {
      button.addEventListener('click', (e) => this.toggleDropdown(e.currentTarget));
    });

    // Close dropdowns on outside click
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.desktop-nav-item')) {
        this.closeAllDropdowns();
      }
    });

    // Close dropdowns on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeAllDropdowns();
      }
    });
  }

  toggleDropdown(button) {
    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    // Close all other dropdowns first
    this.closeAllDropdowns();

    // Toggle this dropdown
    if (!isExpanded) {
      button.setAttribute('aria-expanded', 'true');
    }
  }

  closeAllDropdowns() {
    this.buttons.forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new DesktopNav());
} else {
  new DesktopNav();
}

export default DesktopNav;
